import { render, staticRenderFns } from "./MainStoreWeb.vue?vue&type=template&id=c5b34ac0&scoped=true&"
import script from "./MainStoreWeb.vue?vue&type=script&lang=js&"
export * from "./MainStoreWeb.vue?vue&type=script&lang=js&"
import style0 from "@/less/storeWeb.less?vue&type=style&index=0&id=c5b34ac0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b34ac0",
  null
  
)

export default component.exports